import React, { useState, useEffect } from "react";
import {
  getGlobalSetting,
  updateGlobalSetting,
} from "../../../services/AdminService";
import { useAxiosInstance } from "../../../services/Interceptor";
import { toast } from "react-toastify";

const GraduatedClass = () => {
  const [graduatedClass, setGraduatedClass] = useState("");
  const [loadingGraduatedClass, setLoadingGraduatedClass] = useState(false);
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    const fetchGraduatedClass = async () => {
      try {
        const response = await getGlobalSetting(apiInstance, "graduatedClass");
        const value = response?.data ?? response;
        setGraduatedClass(value?.toString() ?? "");
      } catch (err) {
        toast.error("Failed to load graduated class");
      }
    };

    fetchGraduatedClass();
  }, [apiInstance]);

  const handleGraduatedClassSave = async () => {
    setLoadingGraduatedClass(true);
    try {
      await updateGlobalSetting(apiInstance, "graduatedClass", graduatedClass);
      toast.success("Graduated class updated successfully");
    } catch (err) {
      const errorMessage =
        err?.response?.data?.error || "Failed to update graduated class";
      toast.error(errorMessage);
    } finally {
      setLoadingGraduatedClass(false);
    }
  };

  return (
    <div className="mb-6">
      <h1 className="text-xl mb-4 uppercase">Preferences</h1>
      <div className="w-full">
        <label
          htmlFor="adminEmail"
          className="block mb-1 text-sm font-medium text-gray-700"
        >
          Graduated Class
        </label>
        <div className="flex items-center gap-4">
          <input
            type="text"
            value={typeof graduatedClass === "string" ? graduatedClass : ""}
            onChange={(e) => setGraduatedClass(e.target.value)}
            placeholder="Ej: 2024"
            className="flex-1 px-4 py-2 rounded-lg border border-gray-300 
               text-gray-700 placeholder-gray-400 
               focus:outline-none focus:ring-2 focus:ring-indigo-400 
               focus:border-indigo-400 transition"
          />
          <button
            onClick={handleGraduatedClassSave}
            disabled={loadingGraduatedClass}
            className="px-6 py-2.5 rounded text-sm
               bg-red-500 text-white cursor-pointer
               hover:bg-red-600 
               active:scale-95 
               transition-all duration-200"
          >
            {loadingGraduatedClass ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GraduatedClass;
